import { render, staticRenderFns } from "./claim-settle-dialog.vue?vue&type=template&id=65f35ceb&scoped=true&"
import script from "./claim-settle-dialog.vue?vue&type=script&lang=js&"
export * from "./claim-settle-dialog.vue?vue&type=script&lang=js&"
import style0 from "./claim-settle-dialog.vue?vue&type=style&index=0&id=65f35ceb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f35ceb",
  null
  
)

export default component.exports